import React from "react";
import { useState, useEffect,useCallback,useRef  } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  convertDOBtoMonth,
  formatMeasurement,
  convertS3privateToPublic,
  goBack,
  calculateAgeRange,
  convertDOBtoAge,flatPickerFormatDate
} from "./../../services/UtilsService";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ApiService from "../../services/ApiService";
import { validate } from "./../../services/ValidationService";
import { generateRandomId } from "../../services/UtilsService";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { useTranslation } from 'react-i18next';

const AddMeasurement = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  const formattedToday = `${yyyy}-${mm}-${dd}`;
  // Initial state declaration
  const [memberData, setMemberData] = useState([]);
  const [data, setData] = useState({age_by:false,measurement_date: formattedToday});
  const [error, setError] = useState({});
  const [patient, setPatient] = useState([]);
  const [range, setRange] = useState([]);
  const [ageRange, setAgeRange] = useState("");
  const [dob, setDob] = useState("");
  const [age, setAge] = useState("");
  const [parentData, setParentData] = useState([]);
  const navigate = useNavigate();
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
	const role = Number(localStorage.getItem('role'));
  const flatpickrRef = useRef(null); // Create a ref for Flatpickr
  const { t } = useTranslation();
  const currentLang = localStorage.getItem('i18nextLng');
  
  useEffect(() => {
    // Simulate fetching dob (replace with actual logic)
    const fetchedDob = dob; // Example dob
    setDob(fetchedDob);
  }, []);

  useEffect(() => {
    if (flatpickrRef.current && dob) {
      // Update Flatpickr options dynamically when dob changes
      flatpickrRef.current.flatpickr.set("minDate", dob);
    }
  }, [dob]);

  /**
   * Validation schema for Measurement Fields
   * @patient_name - required field and pass the Measurement patient_name
   * @age_by - required field and pass the Measurement age_by
   * @age_range - required field if @age_by is range and pass the Measurement select_range
   * @measurement_date - required field if @age_by is date and pass the Measurement measurement_date
   * @weight - required field if @height is null and pass the Measurement weight
   * @height - required field if @weigth is null and pass the Measurement height
   * @head_circumference - pass the Measurement head_circumference
   * @bmi - pass the Measurement body_mass_index
   **/

  const Fields = [
    /* {
      name: "patient_name",
      validation: Yup.string().required("Patient name is required"),
    }, */
    {
      name: "age_by",
      validation: Yup.boolean().required(t('error.ageByRequired')),
    },
    {
      name: "age_range",
      validation:
        data.age_by === true
          ? Yup.string().required(t('error.ageRangeRequired'))
          : Yup.string(),
    },
    {
      name: "measurement_date",
      validation:
        data.age_by === false
          ? Yup.string().required(t('error.measurementDateRequired'))
          : Yup.string(),
    },
    {
      name: "weight",
      validation: Yup.string().test(
        "weightOrLengthRequired",
        t('error.weightOrLengthReq'),
        function (value) {
          const { height } = this.parent;
          if (!value && !height) {
            return false;
          }
          return true;
        }
      ),
    },
  ];

  //Component Initialize function trigger when request id change
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        var response = await ApiService.getMemberProfile(id);
        if (response.status === 200) {
          setMemberData({
            ...response.data.item,
            dobs: convertDOBtoMonth(response.data?.item?.dob, t),
          });
          setParentData(response.data.parentInfo);
          setAge(calculateAge(response.data?.item?.dob));
          
          setDob(response.data?.item?.dob);
          console.log("DOB : ",dob);
        }
      } catch (error) {
        console.error("Error fetching member data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id]);

  useEffect(() => {
    const fetchRange = async () => {
      try {
        const responseName = await ApiService.listFamilyMember({
          page: 0,
          limit: 100,
          clinics: [],
          age_range: [],
          sort: "updated",
        });
        const responseAge = await ApiService.masterMeasurementAges();

        if (responseName.status !== 200 || responseAge.status !== 200) {
          throw new Error("Failed to fetch data");
        }

        // responseName.data.items contains the patient data
        setPatient(responseName.data.data);

        // responseAge.data.items contains the patient age range
        setRange(responseAge.data.items);
        console.log("Drop down Range : ",responseAge);
      } catch (error) {
        console.error(error);
      }
    };

    fetchRange();
  }, []);

  const calculateBMI = () => {
    const weight = parseFloat(data.weight);
    const heightInCm = parseFloat(data.height); // Height in centimeters
    const heightInM = heightInCm / 100; // Convert height to meters

    if (!isNaN(weight) && !isNaN(heightInCm) && heightInCm > 0) {
      const bmi = (weight / (heightInM * heightInM)).toFixed(2);
      setData((prevData) => ({ ...prevData, bmi: bmi })); // Update BMI in state
    } else {
      // Optional: Handle invalid inputs by resetting BMI or showing an error
      setData((prevData) => ({ ...prevData, bmi: "0" }));
    }
  };

  useEffect(() => {
    calculateBMI();
  }, [data.weight, data.height]);

  const calculateAge = (dob) => {
    // Convert DOB string to Date object
    const dobDate = new Date(dob);
    // Get current date
    const currentDate = new Date();

    // Calculate age in months
    const yearsDiff = currentDate.getFullYear() - dobDate.getFullYear();
    const monthsDiff = currentDate.getMonth() - dobDate.getMonth();
    const dayOfMonthDiff = currentDate.getDate() - dobDate.getDate();

    // Adjust for cases where the current day of the month is earlier than the birth day
    let ageInMonths = yearsDiff * 12 + monthsDiff;
    if (dayOfMonthDiff < 0) {
      ageInMonths--;
    }

    return ageInMonths === 0 ? 1:ageInMonths;
  };

  useEffect(() => {
    setData({
      ...data,
      age_range: calculateAgeRange(dob, data?.measurement_date),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.measurement_date]);

  useEffect(() => {
    const selectedPatient = patient.find((option) => option.id === id);
    if (selectedPatient) {
      const newId = generateRandomId();
      setDob(selectedPatient.dob);
      setAge(calculateAge(dob));
      const newAgeRange = calculateAgeRange(dob, data?.measurement_date);
      setAgeRange(newAgeRange);
      setData({
        ...data,
        age_range: data.age_by ? data.age_range : newAgeRange,
        patient_name: selectedPatient.name,
        id: newId,
        member: selectedPatient.id,
        parentId: selectedPatient.parent,
        bmi: data.bmi,
        height: data.height,
        weight: data.weight,
      });
    } else {
      setData({
        ...data,
        isAgeRange: data.age_by,
        patient_name: "",
        id: "",
        member: "",
        parentId: "",
        age_range: "",
        bmi: "0",
        height: undefined,
        weight: undefined,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.age_by]);


  useEffect(() => {
    const selectedPatient = patient.find((option) => option.id === id);
  
    if (selectedPatient) {
      const newId = generateRandomId();
      setData({
        ...data,
        id: newId,
        member: selectedPatient.id,
        parentId: selectedPatient.parent,
        patient_name: selectedPatient.name,
        age_by: false,
        measurement_date: formattedToday,
        age_range: calculateAgeRange(selectedPatient.dob, formattedToday),
        bmi: "",
        height: "",
        weight: "",
      });
      setDob(selectedPatient.dob);
      setAge(calculateAge(selectedPatient.dob));
      setAgeRange(calculateAgeRange(selectedPatient.dob, formattedToday));
    }
  }, [id, patient]);
  
  /**
   * To handle input change event
   * @e - we get the event details from the Change action
   **/
  const handleChange = async (e) => {
    const { name, value } = e.target;
    const updatedValue = name === "age_by" ? value === "true" : value;
    if (name === "age_by") {
      console.log("Run 1");
      if (value === "false") {
        console.log("Run 2");
        setData({
          ...data,
          [name]: updatedValue,
          age_range: calculateAgeRange(dob, formattedToday),
          measurement_date: formattedToday,
        });
      } else {
        setData({ ...data, [name]: updatedValue, age_range: "", measurement_date: "" });
      }
      setData({ ...data, [name]: updatedValue, age_range: "" });
      const selectedPatient = patient.find((option) => option.id === id);
      if (selectedPatient) {
        console.log("Run 3");
        const newId = generateRandomId();
        setAge(calculateAge(dob));
        setAgeRange(calculateAgeRange(dob, data?.measurement_date));
        setDob(selectedPatient.dob);
        setData({
          ...data,
          [name]: updatedValue,
          isAgeRange: data.age_by,
          patient_name: selectedPatient.name,
          id: newId,
          member: selectedPatient.id,
          parentId: selectedPatient.parent,
          age_range: data.age_by ? data.age_range : ageRange,
          bmi: data.bmi,
          height: data.height,
          weight: data.weight,
        });
      } else {
        setData({
          ...data,
          [name]: updatedValue,
          isAgeRange: data.age_by,
          patient_name: "",
          id: "",
          member: "",
          parentId: "",
          age_range: "",
          bmi: "0",
          height: "0",
          weight: "0",
        });
      }
    } else {
      setData({ ...data, [name]: updatedValue, isAgeRange: data.age_by });
    }
    if (name === "age_by" && value === "false") {
      console.log("Run 4");
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      const formattedToday = `${yyyy}-${mm}-${dd}`;
      setData({
        ...data,
        [name]: updatedValue,
        age_range: calculateAgeRange(dob, formattedToday),
        measurement_date: formattedToday,
      });
    } else {
      setData({ ...data, [name]: updatedValue, isAgeRange: data.age_by });
    }
    const Errors = await validate({ [name]: value }, Fields);
    setError({ ...error, [name]: Errors[name] });
    // Check if the length field is being updated and it's not empty
    if (name === "height" && value.trim() !== "") {
      console.log("Run 5");
      // Check if the weight field is currently invalid
      if (error.weight) {
        // Clear the error state for weight
        setError({ ...error, weight: "" });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const currentDate = new Date();
    const Errors = await validate(data, Fields);
    await setError(Errors);

      // Remove height or weight if null or empty
      const sanitizedData = { ...data };
      if (!sanitizedData.height) {
          delete sanitizedData.height;
      }
      if (!sanitizedData.weight) {
          delete sanitizedData.weight;
      }
    // Set createdAt
    const newData = {
      ...sanitizedData,
      createdAt: currentDate
        .toISOString()
        .replace("Z", "+05:30")
        .replace("T", " "),
    };

    if (Object.keys(Errors).length === 0) {
      // Check if there are no validation errors
      try {
        // Send request to server
        const response = await ApiService.createMeasurement(newData);
        // Handle response
        if (response.status === 200) {
          toast.success(response?.data?.message);
          if(role===4){
            navigate("/hospital/admin/children");
          }else{
          navigate("/physician/measurement");
          }
        } else {
          toast.error(response?.data?.message || "Something went wrong");
        }
      } catch (error) {
        // Handle error
        console.error("Error:", error);
      }
    }
  };

  //To handle the form reset
  const handleCancel = () => {
    setData({
      age_by: false, // Default to Date option
      measurement_date: formattedToday, // Reset to today's date
    });
    setError({});
  };

    // State to store the initial valid options (up to the prefilled age_range)
    const [validOptions, setValidOptions] = useState([]);

    useEffect(() => {
      // Check if valid options are already set; if not, set them based on prefilled data.age_range
      if (data.age_by === true && !validOptions.length) {
        console.log("Setting valid options based on initial data.age_range:", data.age_range);
        
        const initialValidOptions = range
          .sort((a, b) => a.id - b.id) // Sort the range array based on option.id
          .filter((option) => option.id <= data.age_range); // Filter options based on prefilled age_range
  
        console.log("Filtered valid options (based on prefilled data.age_range):", initialValidOptions);
        
        setValidOptions(initialValidOptions); // Store the filtered options once
      }
    }, [data.age_by, data.age_range, range, validOptions.length]); // Ensures we set validOptions only once
  
  //Bind the age range
	const getLocalizedAgeRange = (age) => {
		if (currentLang === 'ta') {
			return age.name_tamil || age.name; // fallback if tamil not present
		}
		return age.name;
	};

  return (
    <>
      <main id="main" className="main">
        {/* Page Title Section */}
        <div className="pagetitle clearfix">
          <div className="float-start">
            <h1>{t('common.addMeasurement')}</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={role===4 ? '/hospital/admin/dashboard' : '/physician/dashboard'}>{t('sidebar.home')}</Link>
                </li>
                <li className="breadcrumb-item active">{t('common.addMeasurement')}</li>
              </ol>
            </nav>
          </div>
          <div className="float-end mt-2 me-1">
            <span onClick={goBack} className="backIcon">
              <i className="iconly-Bold-ArrowLeftSquare"></i>
            </span>
          </div>
          {/* End Buttons */}
        </div>
        {/* End Page Title Section */}
        {/* Page Content Section */}
        <section className="pagesection">
          <div className="row">
            <div className="col-xxl-12">
              <form className="form-card p-2">
                {/*Patient(kids) Info*/}
                {!isLoading && (
                  <>
                    <div className="row">
                      <div
                        className={
                          memberData.gender === 0
                            ? "col-lg-12 male"
                            : "col-lg-12 female"
                        }
                      >
                        <div className="d-md-flex align-items-center ps-1">
                          <div className="avtar-img">
                            <span className="rounded-circle">
                              {memberData?.photo === "default.png" ? (
                                <img
                                  className="img-fluid d-block mx-auto"
                                  src="/assets/img/user-avatar.png"
                                  alt="UN"
                                />
                              ) : (
                                <img
                                  className="img-fluid d-block mx-auto"
                                  src={convertS3privateToPublic(
                                    memberData?.photo
                                  )}
                                  alt="UN"
                                />
                              )}
                            </span>
                          </div>
                          <div className="ms-lg-2">
                            <Link to={role === 4 ? '/hospital/admin/view-children/' + memberData?.id : '/physician/member-profile/' + memberData?.id}>
                              <h5 className="table-title fw-bold">
                                {memberData.name ? memberData?.name : "--"}
                              </h5>
                            </Link>
                            <p className={`table-subtitle ${role === 4 ? 'admin-table-subtitle' : ''}`}>
                              <span>
                                {memberData.gender === 0 ? t('common.boy') :  t('common.girl')}
                              </span>{" "}
                              - {convertDOBtoAge(memberData.dob, t)}
                            </p>
                          </div>
                          <div className="ms-lg-5">
                            <p className="mb-0 small">{t('sidebar.parent')}</p>
                            <p className="mb-0 table-subtitle">
                              {parentData.first_name
                                ? parentData?.first_name +
                                  " " +
                                  parentData?.last_name
                                : "--"}
                            </p>
                          </div>
                          <div className="ms-lg-5">
                            <p className="mb-0 small">{t('table.bloodGroup')}</p>
                            <p className="mb-0 table-subtitle">
                              {memberData.blood_group
                                ? memberData?.blood_group
                                : "--"}
                            </p>
                          </div>
                          <div className="ms-lg-5">
                            <p className="mb-0 small">{t('table.weight')} / {t('table.height')}</p>
                            <p className="mb-0 table-subtitle">
                              {memberData.latest_weight &&
                              memberData.latest_weight !== "0"
                                ? `${formatMeasurement(
                                    memberData.latest_weight
                                  )} ${t('common.kg')}`
                                : "--"}{" "}
                              /{" "}
                              {memberData?.latest_height &&
                              memberData.latest_height !== "0"
                                ? `${formatMeasurement(
                                    memberData.latest_height
                                  )} ${t('common.cm')}`
                                : "--"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="my-3" />
                  </>
                )}
                {/*--*/}
                <div className="row">
                  {/*  <div className="col-lg-4 col-md-6">
                    <div className="form-group">
                      <label>Patient Name</label>
                      <select
                        className="form-select"
                        value={data.patient_name || ""}
                        name="patient_name"
                        onChange={handleChange}
                      >
                        <option value="">Select Patient Name</option>
                        {patient.map((option) => (
                          <option key={option.id} value={option.name}>
                            {option.name}
                          </option>
                        ))}
                      </select>
                      {error && error.patient_name && (
                        <span className="required">{error.patient_name}</span>
                      )}
                    </div>
                  </div> */}
                  <div className="col-lg-4 col-md-6">
                    <div className=" form-group">
                      <label>{t('common.ageBy')}</label>
                      <div
                        className="ChecksRadios"
                        style={{ backgroundColor: "#f0f4f4" }}
                      >
                        <div className="form-check form-check-inline">
                          <input
                            className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`}
                            type="radio"
                            value="true"
                            name="age_by"
                            onChange={handleChange}
                            id="inlineRadio1"
                            checked={data.age_by === true}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            {" "}
                            {t('common.range')}
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className={`form-check-input ${role === 4 ? 'admin-form-check-input' : ''}`}
                            type="radio"
                            id="inlineRadio3"
                            value="false"
                            name="age_by"
                            onChange={handleChange}
                            checked={data.age_by === false}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="inlineRadio3"
                          >
                            {" "}
                            {t('modal.date')}
                          </label>
                        </div>
                      </div>
                      {error && error.age_by && (
                        <span className="required">{error.age_by}</span>
                      )}
                    </div>
                  </div>

                  {data.age_by === true ? (
                    <>   
                    {console.log("Age:", convertDOBtoAge(memberData.dob, t))}
                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <label>{t('common.range')}</label>
                        <select
                          className="form-select"
                          value={data.age_range || undefined}
                          name="age_range"
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            console.log("User selected Age Range:", selectedValue); // Log when the user selects an option
                            handleChange(e);
                          }}
                        >
                          <option disabled>{t('common.selectAgeRange')}</option>
                          {validOptions.map((option) => (
                  <option key={option.id} value={option.id}>
                    {getLocalizedAgeRange(option)}
                  </option>
                ))}
                             {console.log("Range -----> :", range)}
                        </select>
                        {console.log("Prefilled Age Range:", data.age_range)} {/* Log the prefilled selected option */}
                        {error && error.age_range && (
                          <span className="required">{error.age_range}</span>
                        )}
                      </div>
                    </div>
                    {console.log("Bound value (age_range):", data.age_range)}
                    </>
                  ) : (
                    <div className={`col-lg-4 col-md-6 ${
                      role === 4  ? 'admin-flatpicker' : 'flatpicker'
                    }`}>
                      <div className="form-group">
                        <label>{t('common.measurementSelectDate')}</label>
                        {/* <input
                          type="date"
                          value={data.measurement_date || ""}
                          name="measurement_date"
                          className={`form-control ${role === 4 ? 'admin-date-input' : ''}`}
                          onChange={handleChange}
                          min={dob}
                          max={new Date().toISOString().split("T")[0]}
                        /> */}
                        <div className="input-group">
                          <Flatpickr
                          value={data.measurement_date || ""}
                          name="measurement_date"
                          onChange={(selectedDates) => {
                            const selectedDate = selectedDates[0]; // Get the selected date
                            if (selectedDate) {
                            // Format the date as 'YYYY-MM-DD'
                            const formattedDate = flatPickerFormatDate(selectedDate);
                              handleChange({
                                target: {
                                  name: "measurement_date",
                                  value: formattedDate, // Format as YYYY-MM-DD
                                },
                              });
                            }
                          }}
                          options={{
                            dateFormat: "Y-m-d", // Format of the date
                            maxDate: "today", // Minimum date as today
                            minDate : dob
                          }}
                          placeholder={t('profile.selectDate')}
                          className="form-control" // Optional: Add a CSS class
                          ref={flatpickrRef} // Bind Flatpickr to the ref
                          />
                          {/* Calendar Icon */}
                          <span className="input-group-text input-button" title="toggle"
                          onClick={() => flatpickrRef.current.flatpickr.open()}>
                            <i className="ri-calendar-line"></i>
                          </span>
                        </div>
                        {error && error.measurement_date && (
                          <span className="required">
                            {error.measurement_date}
                          </span>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-lg-4 col-md-6">
                    <div className=" form-group">
                      <label>{t('table.weight')}</label>
                      <div className="input-group mb-3">
                        <input
                          type="number"
                          value={data.weight || ""}
                          name="weight"
                          className="form-control w-50"
                          placeholder={t('common.enterWeight')}
                          onChange={handleChange}
                          onInput={(e) => {
                            if (e.target.value.length > 5) {
                              e.target.value = e.target.value.slice(0, 5);
                            }
                            if (e.target.value < 0) {
                              e.target.value = "";
                            }
                          }}
                        /><span className="form-control measurementUnit-center w-30">{t('common.kg')}</span>
                        {/* <select
                          className="form-select w-30"
                          value={data.weight_unit || "Kg"}
                          name="weight_unit"
                          onChange={handleChange}
                        >
                          <option value="Kg">kg </option>
                          <option value="lbs">lbs</option>
                        </select> */}
                        {error && error.weight && (
                          <span className="required">{error.weight}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    {/* <div className="col-lg-4 col-md-6">
                      <div className=" form-group">
                        <label>Weight</label>
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            value={data.weight || ""}
                            name="weight"
                            className="form-control w-50"
                            placeholder="Enter Weight"
                            onChange={handleChange}
                          />
                          <select
                            className="form-select w-30"
                            value={data.weight_unit || "Kg"}
                            name="weight_unit"
                            onChange={handleChange}
                          >
                            <option value="Kg">kg </option>
                            <option value="lbs">lbs</option>
                          </select>
                          {error && error.weight && (
                            <span className="required">{error.weight}</span>
                          )}
                        </div>
                      </div>
                    </div> */}

                    <div className="col-lg-4 col-md-6">
                      <div className=" form-group">
                        <label>{t('table.height')}</label>
                        <div className="input-group mb-3">
                          <input
                            type="number"
                            value={data.height || ""}
                            name="height"
                            className="form-control w-50"
                            placeholder={t('common.enterLength')}
                            onChange={handleChange}
                            onInput={(e) => {
                              if (e.target.value.length > 5) {
                                e.target.value = e.target.value.slice(0, 5);
                              }
                              if (e.target.value < 0) {
                                e.target.value = "";
                              }
                            }}
                          /><span className="form-control measurementUnit-center w-30">{t('common.cm')}</span>
                          {/* <select
                            className="form-select w-30"
                            value={data.height_unit || "cm"}
                            name="height_unit"
                            onChange={handleChange}
                          >
                            <option value="cm">cm </option>
                            <option value="feet">feet</option>
                            <option value="m">m</option>
                          </select> */}
                        </div>
                      </div>
                    </div>

                    {age <= 24 ? (
                      <div className="col-lg-4 col-md-6">
                        <div className=" form-group">
                          <label>{t('table.head')}</label>
                          <div className="input-group mb-3">
                            <input
                              type="number"
                              className="form-control w-50"
                              placeholder= {t('common.enterHead')}
                              value={data.head_circumference || ""}
                              name="head_circumference"
                              onChange={handleChange}
                              onInput={(e) => {
                                if (e.target.value.length > 5) {
                                  e.target.value = e.target.value.slice(0, 5);
                                }
                                if (e.target.value < 0) {
                                  e.target.value = "";
                                }
                              }}
                            /><span className="form-control measurementUnit-center w-30">cm</span>
                            {/* <select
                              className="form-select w-30"
                              value={data.head_circumference_unit || "inches"}
                              name="head_circumference_unit"
                              onChange={handleChange}
                            >
                              <option value="inches">inches</option>
                              <option value="cm">cm </option>
                              <option value="m">m</option>
                            </select> */}
                          </div>
                          {/* {error && error.head_circumference && (
                                              <span className="required">
                                                {error.head_circumference}
                                              </span>
                                            )} */}
                        </div>
                      </div>
                    ) : null}

                    <div className="col-lg-4 col-md-6">
                      <div className="form-group">
                        <label>{t('common.bmi')} (BMI)</label>
                        <div className="input-group mb-3">
                        <input
                          type="text"
                          value={data.bmi || "0"}
                          name="bmi"
                          className="form-control w-50"
                          placeholder= {t('common.autoUpdate')}
                          readOnly
                        /><span className="form-control measurementUnit-center w-30">{t('common.kg')}/{t('common.meter')}<sup>2</sup></span>
                        {/* {error && error.bmi && (
                          <span className="required">
                            {error.bmi}
                          </span>
                        )} */}
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Button Section */}
                <div className="row">
                  <div className="col-lg-12 text-end">
                    <button
                      type="button"
                      className={`btn ${role===4?'btn-tmAquaDgreen':'btn-secondary'} me-2`}
                      onClick={handleCancel}
                    >
                      <i className="ri-arrow-left-line align-middle"></i> {t('common.reset')}
                    </button>
                    <button
                      type="button"
                      className={`btn ${role===4?'btn-tmAquaGreen':'btn-tmBlue'}`}
                      onClick={handleSubmit}
                    >
                      <i className="ri-check-double-fill align-middle"></i>{" "}
                      {t('profile.submit')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
        {/* End Page Content Section */}
      </main>
    </>
  );
};

export default AddMeasurement;
